import { fetchAPI, sendNotification } from '@bsd/dashboard-toolkit/utils'

import { loadGeoSections, loadGeoSection } from './geoSections'


export const loadGeoCategory = (categoryId) => async (dispatch) => {
  dispatch({ type: 'LOAD_GEO_CATEGORY' })
  try {
    const category = await fetchAPI(`/in/globe3d/geo-categories/${categoryId}`)
    dispatch({ type: 'LOAD_GEO_CATEGORY_SUCCESS', category })
  } catch (error) {
    dispatch({ type: 'LOAD_GEO_CATEGORY_FAIL', error })
  }
}

export const createGeoCategory = (data) => async (dispatch) => {
  dispatch({ type: 'CREATE_GEO_CATEGORY' })
  try {
    if (data.icon instanceof File) {
      const { iconPath } = await fetchAPI(`/in/globe3d/geo-categories/icons`, 'POST', {
        icon: data.icon,
      }, true)
      data.icon = iconPath
    }
    const category = await fetchAPI(`/in/globe3d/geo-categories`, 'POST', data)

    if (data.sectionId) dispatch(loadGeoSection(data.sectionId))

    dispatch({ type: 'CREATE_GEO_CATEGORY_SUCCESS', category })
    sendNotification({ level: 'success', message: 'Категория успешно создана' })
    return category
  } catch (error) {
    dispatch({ type: 'CREATE_GEO_CATEGORY_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const updateGeoCategory = (categoryId, data) => async (dispatch) => {
  dispatch({ type: 'UPDATE_GEO_CATEGORY' })
  try {
    if (data.icon instanceof File) {
      const { iconPath } = await fetchAPI(`/in/globe3d/geo-categories/icons`, 'POST', {
        icon: data.icon,
      }, true)
      data.icon = iconPath
    }
    const category = await fetchAPI(`/in/globe3d/geo-categories/${categoryId}`, 'PUT', data)
    dispatch({ type: 'UPDATE_GEO_CATEGORY_SUCCESS', category })
    sendNotification({ level: 'success', message: 'Категория успешно сохранена' })
  } catch (error) {
    dispatch({ type: 'UPDATE_GEO_CATEGORY_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const deleteGeoCategory = (categoryId) => async (dispatch) => {
  dispatch({ type: 'DELETE_GEO_CATEGORY' })
  try {
    await fetchAPI(`/in/globe3d/geo-categories/${categoryId}`, 'DELETE')
    dispatch(loadGeoSections())
    dispatch({ type: 'DELETE_GEO_CATEGORY_SUCCESS', categoryId })
    sendNotification({ level: 'success', message: 'Категория успешно удалена' })
  } catch (error) {
    dispatch({ type: 'DELETE_GEO_CATEGORY_FAIL', error })
    sendNotification({ level: 'error', message: 'При удалении произошла ошибка' })
  }
}